/* file description */
import React, { FC, useState, useEffect } from 'react';
import { COLUMN_FROM } from '../../effects/consts';
import { getOpenApiDataCache } from '@/common/asset-apis/assetModel';

import { ReferenceRenderProps } from './type';

export const OpenApiSelectModalRender: FC<ReferenceRenderProps> = ({
  field,
  API,
  targerValue,
  rowsData,
  columnFrom,
  setViewValue,
  storeValue,
  entity,
}) => {
  const { value, label, openApiUrl, apiKeyList, apiType = 'get' } = field?.bizConfig || {};
  const [renderData, setRenderData] = useState<any>('');
  const [params, setParams] = useState<any>({});

  useEffect(() => {
    const apiParamsList: Record<any, any> = {};
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      apiKeyList.forEach((item: any) => {
        apiParamsList[item.apiKey] = headData?.[item.apiValueModule];
      });
      setParams(apiParamsList);
    }
    if (columnFrom === COLUMN_FROM.TABLE) {
      apiKeyList.forEach((item: any) => {
        apiParamsList[item.apiKey] = entity?.[item.apiValueModule];
      });
      setParams(apiParamsList);
    }
  }, [storeValue]);

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    const pass = Object.keys(params).every((key: string) => params[key]);
    if (pass && Object.keys(params)?.length > 0) {
      getOpenApiDataCache(API?.FetchAPI, apiType, openApiUrl, params).then((res: any) => {
        const findDictItem = res?.find((item: Record<any, any>) => item[value] === targerValue) || {};
        setRenderData(findDictItem[label] || targerValue);
      });
    }
  }, [JSON.stringify(params)]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  return renderData;
};
export default OpenApiSelectModalRender;
